import { SORT_DIRECTION } from '@/shared/constants/sort/sortDirection'
import { SORT_ORDER } from '@/shared/constants/sort/sortOrder'

export default {
  SET_ITEMS(state, { payload, version }) {
    if (version !== state._requestVersion) return

    if (state.page === 1) {
      state.items = payload.invoices || []
    } else {
      state.items = [...state.items, ...(payload.invoices || [])]
    }
    state.total = payload.total ?? 0
    state.statistics = {
      total: payload.total,
      total_all: payload.total_all,
      total_finished: payload.total_finished,
      total_finished_amount: payload.total_finished_amount,
      total_partially_paid: payload.total_partially_paid,
      total_waiting_for_deposit: payload.total_waiting_for_deposit,
      total_waiting_amount: payload.total_waiting_amount,
      total_expired: payload.total_expired,
      total_cancelled: payload.total_cancelled,
      total_expired_amount: payload.total_expired_amount,
      total_partially_paid_amount: payload.total_partially_paid_amount,
      total_cancelled_amount: payload.total_cancelled_amount,
      total_partner_fee: payload.total_partner_fee,
      total_buyer_fee: payload.total_buyer_fee,
    }
  },

  INCREMENT_REQUEST_VERSION(state) {
    state._requestVersion += 1
  },

  SET_SEARCH(state, payload) {
    state.search = payload
  },

  SET_STATUS_FILTER(state, payload) {
    state.statusFilter = payload
  },

  SET_DATE_FROM_FILTER(state, payload) {
    state.dateFromFilter = payload
  },

  SET_DATE_TO_FILTER(state, payload) {
    state.dateToFilter = payload
  },

  SET_IS_ONE_TIME_FILTER(state, payload) {
    state.isOneTimeFilter = payload
  },

  SET_IS_UNFIXED_AMOUNT_FILTER(state, payload) {
    state.isUnfixedAmountFilter = payload
  },

  SET_LOADING(state, status) {
    state.loading = status
  },

  SET_ACTION_LOADING(state, payload) {
    state.actionLoading = payload
  },

  SET_POLLING_LOADING(state, payload) {
    state.pollingLoading = payload
  },

  SET_SORT(state, payload) {
    state.sort = payload
  },

  SET_CHRONOLOGY_SORT(state, payload) {
    state.chronologySort = payload
  },

  SET_PAGE(state, payload) {
    state.page = payload
  },

  RESET_PAGE(state) {
    state.items = []
    state.page = 1
    state.total = 0
  },

  RESET_SEARCH(state) {
    state.search = null
  },

  RESET_FILTERS(state) {
    state.search = null
    state.statusFilter = null
    state.dateFromFilter = null
    state.dateToFilter = null
    state.isOneTimeFilter = null
    state.isUnfixedAmountFilter = null
  },

  RESET_STORE(state, { resetSort = true, resetFilters = true } = {}) {
    state.items = []
    state.page = 1
    state.total = 0
    state._requestVersion = 0

    if (resetFilters) {
      state.statusFilter = null
      state.dateFromFilter = null
      state.dateToFilter = null
      state.isOneTimeFilter = null
      state.isUnfixedAmountFilter = null
    }

    if (resetSort) {
      state.sort = {
        sort_by: SORT_ORDER.CREATED_AT,
        sort_direction: SORT_DIRECTION.DESC,
      }
    }
  },

  SET_CURRENT_INVOICE(state, payload) {
    state.currentInvoice = payload
  },

  RESET_CURRENT_INVOICE(state) {
    state.currentInvoice = null
  },
}
